import { render, staticRenderFns } from "./ColumnTransactionStatusLinxPaykitTef.vue?vue&type=template&id=ee760c84&scoped=true"
import script from "./ColumnTransactionStatusLinxPaykitTef.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusLinxPaykitTef.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusLinxPaykitTef.vue?vue&type=style&index=0&id=ee760c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee760c84",
  null
  
)

export default component.exports